import { createRelatedPostsController } from '../../external/related-posts-widget/controller';

export default createRelatedPostsController;
